import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "layouts/Footer";
import TitleCustom from "components/CustomTitle";
import MDBox from "components/MDBox";
import Grid from "@mui/material/Grid";
import DataTable from "examples/Tables/DataTable";

import { useState, useCallback, useEffect } from "react";
import CommonSelect from "components/CommonSelect/select";
import { provincesSync } from "rest/sync/requestsSync";
import { cantonsByProvince } from "rest/requests";
import { parroquiasByCanton } from "rest/requests";
import { storesByProvinceId } from "rest/requests";
import { storesByCantonId } from "rest/requests";
import { storesByParroquias } from "rest/requests";
import { formatTableData } from "./formatTableData";
import HandleWarehouse from "./handleWarehouse";
import { getExcelData } from "./getExcelData";
import MDButton from "components/MDButton";
import AddIcon from "@mui/icons-material/Add";
import { Tooltip } from "@mui/material";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import DropzoneDialogStores from "./dropZone";

function CatastroAlmacenes() {
  const [isHandlingWarehouse, setIsHandlingWarehouse] = useState(false);
  const [elementToEdit, setElementToEdit] = useState(null);

  const [selectedProvince, setSelectedProvince] = useState(null);
  const [selectedCanton, setSelectedCanton] = useState(null);
  const [selectedParroquia, setSelectedParroquia] = useState(null);

  let provincesList = provincesSync();
  const [cantonList, setCantonList] = useState([]);
  const [parroquiaList, setParroquiaList] = useState([]);

  const [stores, setStores] = useState([]);
  const [showLoadFile, setShowLoadFile] = useState(false);
  console.log("Stores: ", stores);

  const getCantonByProvince = useCallback(async () => {
    console.log("Selected Province: ", selectedProvince);
    setCantonList(await cantonsByProvince(selectedProvince));
    setStores(await storesByProvinceId(selectedProvince));
  }, [selectedProvince]);

  useEffect(() => {
    getCantonByProvince();
  }, [selectedProvince]);

  const getParroquiaByCanton = useCallback(async () => {
    console.log("Selected Canton: ", selectedCanton);
    setParroquiaList(await parroquiasByCanton(selectedCanton));
    setStores(await storesByCantonId(selectedCanton));
  }, [selectedCanton]);

  useEffect(() => {
    getParroquiaByCanton();
  }, [selectedCanton]);

  const getData = useCallback(async () => {
    console.log("Selected Parroquia: ", selectedParroquia);
    setStores(await storesByParroquias(selectedParroquia));
  }, [selectedParroquia]);

  useEffect(() => {
    getData();
  }, [selectedParroquia]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <TitleCustom
        title={"Administración de Almacenes"}
        excelData={getExcelData(stores)}
        excelName={"Administracion_de_Almacenes.xlsx"}
      ></TitleCustom>
      {isHandlingWarehouse ? (
        <HandleWarehouse
          elementToEdit={elementToEdit}
          setIsHandlingWarehouse={setIsHandlingWarehouse}
        />
      ) : (
        <div>
          <MDBox bgColor="white" variant="gradient" borderRadius="lg" shadow="lg" opacity={1} p={2}>
            <Grid container>
              <Grid item padding={1}>
                <CommonSelect
                  label="Provincia"
                  data={provincesList.map((e) => {
                    return { id: e.idProvince, name: e.name };
                  })}
                  onChange={(selectedValue) => setSelectedProvince(selectedValue)}
                ></CommonSelect>
              </Grid>
              <Grid item padding={1}>
                <CommonSelect
                  label="Cantón"
                  data={cantonList.map((e) => {
                    return { id: e.idCanton, name: e.name };
                  })}
                  onChange={(selectedValue) => setSelectedCanton(selectedValue)}
                ></CommonSelect>
              </Grid>
              <Grid item padding={1}>
                <CommonSelect
                  label="Parroquia"
                  data={parroquiaList.map((e) => {
                    return { id: e.idParish, name: e.name };
                  })}
                  onChange={(selectedValue) => setSelectedParroquia(selectedValue)}
                ></CommonSelect>
              </Grid>
            </Grid>
            <MDButton
              variant="text"
              size="small"
              color="dark"
              onClick={() => {
                setElementToEdit(null);
                setIsHandlingWarehouse(true);
              }}
            >
              <AddIcon></AddIcon>
              Adicionar Almacen
            </MDButton>
            <Tooltip title={"Subir plantilla .xlsx con los almacenes previamente adicionados"}>
              <MDButton variant="text" color="success" onClick={() => setShowLoadFile(true)}>
                <FileUploadIcon></FileUploadIcon>
                Cargar Almacenes
              </MDButton>
            </Tooltip>
            {showLoadFile ? (
              <DropzoneDialogStores
                open={showLoadFile}
                setOpen={setShowLoadFile}
              ></DropzoneDialogStores>
            ) : (
              <div></div>
            )}
          </MDBox>
          <br></br>
          <DataTable
            canSearch={true}
            table={formatTableData(stores, setIsHandlingWarehouse, setElementToEdit)}
          />
        </div>
      )}
      <Footer />
    </DashboardLayout>
  );
}

export default CatastroAlmacenes;
